import React from 'react';
import {
    Page,
    Card,
    Stack,
    Layout,
    TextStyle,
    Badge,
    Banner,
    IndexTable,
    Icon,
    Tooltip
} from '@shopify/polaris';
import {
    RiskMajor
} from '@shopify/polaris-icons';
import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { apiFetch as fetch } from '../../common/Helpers';
import StatItem from '../../components/filtering/StatItem';
import { Helmet } from 'react-helmet';

function ValidationRulesIndexPage() {

    const history = useHistory();
    const [rules, setRules] = useState([]);
    const [evaluation, setEvaluation] = useState({
        exists: false,
        failingRules: "?",
        failingRuleIds: [],
        failingResources: "?",
        inProgress: false
    });

    useEffect(() => {

        fetch(`api/validationRules`, {
            method: 'get'
        })
            .then(response => response.json())
            .then(data => setRules(data));
    }, []);

    useEffect(() => {

        fetch(`api/validationRules/evaluation`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => setEvaluation(data));

    }, []);

    var requestEvaluation = function () {
        fetch(`api/validationRules/scheduleValidation`, {
            method: 'POST',
        }).then(response => response.json())
            .then(data => setEvaluation(data));
    };

    const rowMarkup = rules.map(
        ({ id, name, enabled, type }, index) => {
            var hasFailures = evaluation.failingRuleIds.includes(id);
            return (
                <IndexTable.Row id={id} key={id} position={index} onNavigation={navigateToRule}>
                    <IndexTable.Cell>{hasFailures && <Stack.Item>
                        <Tooltip content="Rule has failing items">
                            <Icon source={RiskMajor} color="critical" />
                        </Tooltip>
                    </Stack.Item>
                    }</IndexTable.Cell>
                    <IndexTable.Cell>
                        <div data-primary-link>
                            <TextStyle variation="strong">{name}</TextStyle>
                        </div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {enabled && <Badge status="success">Enabled</Badge>}
                        {!enabled && <Badge status="warning">Disabled</Badge>}
                    </IndexTable.Cell>
                    <IndexTable.Cell>{type}</IndexTable.Cell>
                </IndexTable.Row>
            )
        }
    );

    const evaluationInProgress = evaluation != null && evaluation.inProgress;
    const notRecent = evaluation != null && evaluation.notRecent;

    return (
        <div>
            <Helmet>
                <title>Tag Genie - Validation Rules</title>
            </Helmet>
            <Page title="Validation Rules"
                primaryAction={{ content: 'Add Validation Rule', onAction: onCreateRule }}
                secondaryActions={[{ content: 'Schedule Rule Evaluation', onAction: () => { requestEvaluation(); }, disabled: evaluationInProgress }]}>
                <Layout>
                    {evaluationInProgress && <Layout.Section>
                        <Banner
                            title="Evaluation in progress"
                            status="info"
                            onDismiss={null}
                        >
                            <p>The validation rules are being evaluated. Please check back in a couple of minutes and refresh the page.</p>
                        </Banner>
                    </Layout.Section>}
                    {notRecent && <Layout.Section>
                        <Banner
                            title="Not Recent"
                            status="warning"
                            onDismiss={null}
                        >
                            <p>Evaluation of the tag groups hasn't been scheduled recently. Please, schedule a new one to get updates view.</p>
                        </Banner>
                    </Layout.Section>}
                    <Layout.Section title="">
                        <Stack vertical={false} distribution="leading" spacing="extraLoose"  >
                            <Card sectioned>
                                <StatItem
                                    title="Total Rules"
                                    stat={rules.length}
                                    text="Total number of rules."
                                />
                            </Card>
                            <Card sectioned>
                                <StatItem
                                    title="Rules With Errors"
                                    stat={<TextStyle variation="negative">{evaluation.failingRules}</TextStyle>}
                                    text="Number of rules with validation errors."
                                />
                            </Card>
                            <Card sectioned>
                                <StatItem
                                    title="Total Failing Resources"
                                    stat={<TextStyle variation="negative">{evaluation.failingResources}</TextStyle>}
                                    text="Number of resources that do not meet the validation rules."
                                />
                            </Card>
                        </Stack>
                    </Layout.Section>
                    <Layout.Section>
                        <Card title="Created Rules">
                            <IndexTable
                                resourceName={{
                                    singular: 'rule',
                                    plural: 'rules',
                                }}
                                itemCount={rules.length}
                                headings={[
                                    { title: 'Errors' },
                                    { title: 'Name' },
                                    { title: 'Enabled' },
                                    { title: 'Type' },
                                ]}
                                selectable={false}
                            >
                                {rowMarkup}
                            </IndexTable>
                        </Card>
                    </Layout.Section>
                </Layout>
            </Page>
        </div>
    );

    function navigateToRule(id) {

        const rule = rules.filter(_ => _.id === id)[0];
        history.push(`/validation-rules/${rule.type}/${id}`);
    }

    function onCreateRule() {
        history.push(`/validation-rules/create`);
    }
}

export default ValidationRulesIndexPage;